import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=bc1de430&scoped=true&"
import script from "./CustomerReviews.vue?vue&type=script&lang=js&"
export * from "./CustomerReviews.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=bc1de430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1de430",
  null
  
)

export default component.exports